import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=2993aa1a&scoped=true&"
import script from "./Acompanhamento.vue?vue&type=script&lang=js&"
export * from "./Acompanhamento.vue?vue&type=script&lang=js&"
import style0 from "./Acompanhamento.vue?vue&type=style&index=0&id=2993aa1a&prod&scoped=true&lang=css&"
import style1 from "./Acompanhamento.vue?vue&type=style&index=1&id=2993aa1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993aa1a",
  null
  
)

export default component.exports